import React from "react";

import { ScrollView, View } from "react-native";
import MonthlyTimePerWeekClassicComponent from "../../../components/working_time/MonthlyTimePerWeekClassicComponent";
import { Repetition, Unit, WorkingTimeClassicType } from "../../../__generated__/graphql";
import Headline from "../../../components/Headline";
import { DEFAULT_HOURS_PER_WEEK } from "../../../utils";
import type { Meta, StoryObj } from "@storybook/react";

const StoryComponent = () => {
    const [workingTime, setWorkingTime] = React.useState<WorkingTimeClassicType>({
        unit: Unit.Hours,
        repetition: Repetition.Week,
        unitCount: DEFAULT_HOURS_PER_WEEK,
        dailyHours: null,
    });

    return (
        <ScrollView style={{ width: "100%", flex: 1 }}>
            <View style={{ padding: 20 }}>
                <Headline h="3">Working Time Monthly Normal</Headline>
                <MonthlyTimePerWeekClassicComponent
                    workingTime={workingTime}
                    onChange={(v) => {
                        setWorkingTime(v.workingTime);
                    }}
                    hoursPerWeek={DEFAULT_HOURS_PER_WEEK}
                />
            </View>
        </ScrollView>
    );
};

const meta = {
    title: "Screens/Working time",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <ScrollView>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Classic: Story = {};
